// extracted by mini-css-extract-plugin
module.exports = {"liveAddress":"index-module_liveAddress_1MlAL"};